var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAparat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 30,
    viewBox: "0 0 84 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5299 15.193C17.5299 17.4679 14.9503 17.1228 14.9503 17.1228H4.66691C3.06277 17.1228 2.69358 15.8975 2.69358 14.777V13.1254L0 15.2014V15.789C0 18.6257 1.45776 19.6528 4.72046 19.6528H16.0648C18.2605 19.6528 20.2144 18.1976 20.2144 16.1166V10.6686L17.5299 13.1597V15.193Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8989 20.2142H24.145V7.86102L21.8989 10.3834V20.2142Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9508 17.832C26.9508 19.5046 25.9849 20.4454 24.145 20.4454L25.9446 23.0217C26.9676 23.0217 29.7601 22.3253 29.7601 17.609V10.1069L26.9508 12.7878V17.832Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7153 20.2143H36.5965H37.2676H39.1677C40.3143 20.2143 41.2063 19.8131 41.8426 19.0115C42.3971 18.3313 42.6745 17.4651 42.6745 16.4125V11.283L39.9614 13.8436V15.6423C39.9614 16.9325 39.5047 17.5773 38.5909 17.5773H34.1283C34.1283 17.5773 34.1574 16.2584 34.1574 15.5275V7.29956L31.4443 9.89552V16.9613C31.4443 19.1302 32.5344 20.2143 34.7153 20.2143Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7959 20.2142H46.0419V7.86102L43.7959 10.2134V20.2142Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8802 3.3689C40.9155 3.3689 39.8672 6.1847 39.8672 7.21564L42.5327 8.984C42.5327 7.1291 42.9778 6.20121 44.6564 6.20121H47.2834L49.9744 3.3689H44.8802Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27212 10.6686H2.80859V12.9147H11.7928L9.27212 10.6686Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.861 24.1449L42.114 22.0412C42.0902 22.009 42.0699 21.973 42.0448 21.9425C41.4142 21.1646 40.531 20.7759 39.3956 20.7759C39.3956 20.7759 32.0888 20.7805 32.0068 20.7835L34.7388 23.3332H38.5073C39.0559 23.3332 39.5531 23.6664 39.861 24.1449Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0601 24.1449H38.4051C38.9971 24.1449 39.3061 24.8215 39.3061 24.8215L38.4857 25.8294L37.0601 24.1449Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2571 0.825622L63.5392 0.1453C61.1015 -0.465037 58.5999 0.903339 57.9528 3.20146L57.2729 5.61514C59.4611 3.06027 62.6388 1.29233 66.2571 0.825622Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6713 16.8452L54.0486 19.4076C53.4425 21.9016 54.801 24.4601 57.0832 25.1224L59.5194 25.8294C56.9854 23.6516 55.2035 20.478 54.6713 16.8452Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.778 4.10948L76.9282 3.36884C79.7598 5.50713 81.7122 8.70278 82.1711 12.353L82.9538 9.46743C83.5881 7.12918 82.166 4.73047 79.778 4.10948Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1875 28.3292L72.9194 29.0488C75.3123 29.6786 77.7672 28.2662 78.4027 25.8934L79.1717 23.022C77.0456 25.8295 73.8515 27.7952 70.1875 28.3292Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9905 13.9596C71.033 13.5826 69.7515 11.6905 70.1285 9.73259C70.5055 7.77516 72.3981 6.49366 74.3556 6.87064C76.3135 7.24763 77.5946 9.14024 77.2176 11.0977C76.8406 13.0555 74.9479 14.337 72.9905 13.9596ZM75.3787 20.6486C75.0017 22.606 73.109 23.8871 71.1516 23.5105C69.1937 23.1336 67.9121 21.2409 68.2896 19.2831C68.6661 17.3261 70.5588 16.0446 72.5167 16.4211C74.4741 16.7981 75.7557 18.6912 75.3787 20.6486ZM67.8529 15.9827C66.9829 15.8156 66.4131 14.9742 66.5807 14.1042C66.7483 13.2342 67.5893 12.6645 68.4593 12.8316C69.3297 12.9997 69.899 13.8406 69.7314 14.711C69.5638 15.581 68.7228 16.1503 67.8529 15.9827ZM66.3202 18.9044C65.9432 20.8618 64.0505 22.1429 62.0926 21.7663C60.1352 21.3893 58.8541 19.4963 59.2306 17.5393C59.608 15.5814 61.5003 14.2999 63.4577 14.6769C65.4156 15.0539 66.6971 16.9465 66.3202 18.9044ZM61.07 7.98839C61.447 6.03052 63.3396 4.74902 65.2971 5.12644C67.255 5.50342 68.5365 7.39561 68.1591 9.35347C67.7825 11.3109 65.8899 12.5924 63.932 12.2154C61.9745 11.8384 60.693 9.94582 61.07 7.98839ZM68.2243 1.68451C61.2465 1.68451 55.5903 7.3406 55.5903 14.3183C55.5903 21.2959 61.2465 26.9525 68.2243 26.9525C75.2021 26.9525 80.8583 21.2959 80.8583 14.3183C80.8583 7.3406 75.2021 1.68451 68.2243 1.68451Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAparat);
export default __webpack_public_path__ + "static/media/aparat.5d81bbdf2eb9bdd4a06c4675ded42082.svg";
export { ForwardRef as ReactComponent };